import request from '@/utils/request'
//列表
export function workorderList(formId,query) {
  return request({
    url: 'sip/work-order/list/'+ formId,
    method: 'get',
    params: query
  })
}
//根据id查工单
export function workorDer(orderId) {
  return request({
    url: 'sip/work-order/'+ orderId,
    method: 'get',
  })
}

//时间轴 &工单跟踪记录
export function timeLine(workOrderId) {
  return request({
    url: 'sip/work-order/time-line/'+ workOrderId,
    method: 'get',
  })
}
//完结工单
export function workorderClose(orderId) {
  return request({
    url: 'sip/work-order/close/'+orderId,
    method: 'put',
  })
}

//派发工单
export function distribute(data) {
  return request({
    url: 'sip/work-order/distribute',
    method: 'post',
    data: data
  })
}

//同步工单
export function workorderSync(callerPhone) {
  return request({
    url: 'sip/work-order/sync/' + callerPhone,
    method: 'get',
  })
}

//创建工单
export function addWorkOrder(data) {
  return request({
    url: 'sip/work-order',
    method: 'post',
    data: data
  })
}

//处理工单
export function putworkOrder(data) {
  return request({
    url: 'sip/work-order',
    method: 'put',
    data: data
  })
}
export function agentOrder(query) {
  return request({
    url: 'sip/work-order/agent-order',
    method: 'get',
    params: query
  })
}